var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-search-project-statistics"},[_c('userSearchStatisticTemplate',{attrs:{"isFavorite":_vm.isFavorite,"statisticType":"projectStatistics"},on:{"total-count":_vm.setTotalCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }